import axios from 'axios';

export interface NukiIdValidationResult {
  valid: boolean;
  error?: string;
}

/**
 * Asks the backend whether a service can be bought for a Smart Lock ID. The
 * `error` is a translation key of the `NukiIdOverlay` namespace, so the caller
 * shows the reason the backend gave in the language of the page.
 */
export async function nukiIdValidation(
  id: string,
  apiPath: string,
): Promise<NukiIdValidationResult> {
  if (!apiPath) {
    return { valid: false };
  }

  const { data } = await axios.post(apiPath, { deviceId: id });

  if (data?.isBuyable) {
    return { valid: true };
  }

  return {
    valid: false,
    error: data?.notBuyableReason ? data.notBuyableReason : 'Unknown Error has occurred',
  };
}
